/* @ngInject */

import permissionsReportModal from './permissionsReportModal.html';

export default function (params) {
    let {
        $scope,
        toastr,
        DocumentsDocuments,
        PermissionsCategories,
        PermissionsGates,
        PermissionsUsers,
        PermissionsServiceUsers,
        AuthService,
        $uibModal,
        STATUSES,
        $q,
    } = params;

    $scope.permissionsStatus = STATUSES.UNLOADED;

    $scope.permissionsTypes = {
        'gate': 'Gate',
        'category': 'Category',
        'user': 'User',
        'serviceUser': 'Service User',
        'public': 'Public Access',
    };

    $scope.permissionsDirectoryPermissions = {
        'BROWSE': 'Browse',
        'EDIT': 'Edit / Move',
        'DELETE': 'Delete',
        'UPLOAD': 'New Directory / Upload Document',
    };

    $scope.permissionsDocumentPermissions = {
        'DOWNLOAD': 'Download',
        'EDIT': 'Edit / Move',
        'DELETE': 'Delete',
        'UPLOAD': 'Upload New Version',
    };

    $scope.refreshPermissions = () => {
        $scope.permissionsStatus = STATUSES.LOADING;

        $q.all([
            PermissionsGates.getList(),
            PermissionsCategories.getList(),
            PermissionsUsers.getList({
                include: 'workable',
            }),
            PermissionsServiceUsers.getList(),
        ])
            .then((results) => {
                const permissionsGates = results[0];
                const permissionsCategories = results[1];
                const permissionsUsers = results[2];
                const permissionsServiceUsers = results[3];

                const statusGroups = {
                    0: 'Inactive',
                    1: 'Active',
                    2: 'Finished',
                };

                $scope.permissionsGates = permissionsGates;
                $scope.permissionsCategories = permissionsCategories;
                $scope.permissionsUsers = permissionsUsers;
                $scope.permissionsServiceUsers = permissionsServiceUsers.map((serviceUser) => {
                    return {
                        ...serviceUser,
                        shortCode: (serviceUser.shortCode) ? ('SU#' + serviceUser.shortCode) : ('N/A'),
                        statusGroup: statusGroups[serviceUser.status],
                    };
                });

                $scope.permissionsStatus = STATUSES.LOADED;
            })
            .catch((error) => {
                toastr.clear();
                toastr.error('There was an error while loading the list of permissions, please try again.', 'Error');

                $scope.permissionsStatus = STATUSES.ERRORED;
            });
    };

    $scope.permissionsReport = () => {
        $uibModal.open({
            animation: true,
            template: permissionsReportModal,
            scope: $scope,
            size: 'md',
            controller: /* @ngInject */ ($scope, $uibModalInstance, $window, DocumentsService, toastr) => {
                $scope.basicVersion = () => {
                    $window.open(DocumentsService.getDownloadURLForPermissionsReport(), '_blank');

                    toastr.clear();
                    toastr.info('The report will now download in another tab. This may take a few minutes.', 'Downloading...');

                    $uibModalInstance.close();
                };

                $scope.close = () => {
                    $uibModalInstance.close();
                };
            },
        });
    };

}


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/documents/root/controllers/permissions/index.js